import Icon from '../components/Icon.vue'

Icon.register({
  'prescription-bottle': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M32 192v-64h320v352c0 17.6-14.4 32-32 32h-256c-17.6 0-32-14.4-32-32v-64h120c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-120v-64h120c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-120v-64h120c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-120zM360 0c13.2 0 24 10.8 24 24v48c0 13.2-10.8 24-24 24h-336c-13.2 0-24-10.8-24-24v-48c0-13.2 10.8-24 24-24h336z'
      }
    ]
  }
})
